module.exports = __webpack_public_path__ + "img/store_entry_bg.ab8deaf8.png";